import React from "react";

const inputClass = [
  "input",
  "input-bordered",
  "w-full",
  "bg-white",
  "text-sm",
  "dark:bg-slate-900",
  "dark:text-slate-50",
].join(" ");

const selectClass = [
  "select",
  "select-bordered",
  "w-full",
  "bg-white",
  "text-sm",
  "dark:bg-slate-900",
  "dark:text-slate-50",
].join(" ");

function OptionalLabel() {
  return (
    <span className="text-[0.65rem] font-normal text-slate-400">
      (optionnel)
    </span>
  );
}

function SectionTitle({ children }) {
  return (
    <h4 className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-300">
      {children}
    </h4>
  );
}

export default function ActeurFormFields({ data, onChange }) {
  return (
    <>
      {/* Identité */}
      <section>
        <SectionTitle>Identité</SectionTitle>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Nom <span className="text-red-500">*</span>
            </span>

            <input
              className={inputClass}
              type="text"
              name="nom"
              value={data.nom}
              onChange={onChange}
              required
              placeholder="DUPONT"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Prénom <span className="text-red-500">*</span>
            </span>

            <input
              className={inputClass}
              type="text"
              name="prenom"
              value={data.prenom}
              onChange={onChange}
              required
              placeholder="Jean"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Genre <span className="text-red-500">*</span>
            </span>

            <select
              className={selectClass}
              name="genre"
              value={data.genre}
              onChange={onChange}
              required
            >
              <option value="">Sélectionner le genre</option>

              <option value="Masculin">Masculin</option>

              <option value="Féminin">Féminin</option>
            </select>
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Date de naissance <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="date"
              name="date_naissance"
              value={data.date_naissance || ""}
              onChange={onChange}
            />
          </label>
        </div>
      </section>

      {/* Coordonnées */}
      <section className="border-t border-slate-200 pt-4 dark:border-slate-700">
        <SectionTitle>Coordonnées</SectionTitle>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Email <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="email"
              name="email"
              value={data.email}
              onChange={onChange}
              placeholder="exemple@mail.com"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Téléphone <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="tel"
              name="tel"
              value={data.tel}
              onChange={onChange}
              placeholder="06 00 00 00 00"
            />
          </label>

          <label className="block sm:col-span-2">
            <span className="mb-1 block text-xs font-semibold">
              Adresse <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="adresse"
              value={data.adresse}
              onChange={onChange}
              placeholder="12 rue du Dojo"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Code postal <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="cp"
              value={data.cp}
              onChange={onChange}
              placeholder="33000"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Commune <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="commune"
              value={data.commune}
              onChange={onChange}
              placeholder="Bordeaux"
            />
          </label>
        </div>
      </section>

      {/* Informations Judo */}
      <section className="border-t border-slate-200 pt-4 dark:border-slate-700">
        <SectionTitle>Informations Judo</SectionTitle>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Club de l’acteur <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="club_acteur"
              value={data.club_acteur}
              onChange={onChange}
              placeholder="US Bouscat Judo"
            />
          </label>

          <label className="block">
            <span className="mb-1 block text-xs font-semibold">
              Numéro de licence <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="licence_number"
              value={data.licence_number}
              onChange={onChange}
              placeholder="XXXXXXXXX"
            />
          </label>

          <label className="block sm:col-span-2">
            <span className="mb-1 block text-xs font-semibold">
              Groupe souhaité <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="groupe_souhaite"
              value={data.groupe_souhaite}
              onChange={onChange}
              placeholder="Ex : Arbitres régionaux"
            />
          </label>

          <label className="block sm:col-span-2">
            <span className="mb-1 block text-xs font-semibold">
              URL ou chemin de la photo <OptionalLabel />
            </span>

            <input
              className={inputClass}
              type="text"
              name="photo_url"
              value={data.photo_url}
              onChange={onChange}
              placeholder="/img/user_avatar.jpg ou https://..."
            />

            <span className="mt-1 block text-[11px] text-slate-400">
              Vous pouvez utiliser une adresse internet complète ou un chemin
              local.
            </span>
          </label>
        </div>
      </section>
    </>
  );
}
